export const TYPE_LABELS = {
  IN_PROGRESS: 'In Progress',
  cash: 'Cash',
  card: 'Card',
  check: 'Check',
  care_credit: 'Outside Financing',
  ONLINE: 'Card Not Present',
  COF: 'Card on File',
  SWIPE: 'Swipe',
  TOKEN: 'Token',
  CARD_PRESENT: 'Card Present',
  EMV_CONTACT: 'Emv Contact',
  EMV_PROXIMITY: 'Emv Proximity',
  KIOSK_CARD_PRESENT: 'Kiosk Card Present',
  writeoff: 'Write Off',
  billing_cost: 'Billing Cost',
  potential_ar: 'Potential AR',
  UNKNOWN: 'Unknown',
  declined: 'Declined',
  failed: 'Failed',
  BANK_TRANSFER: 'Bank Transfer'
};
